import './Wrapper.scss';

import BaseCtrl from 'edge/platform/base/BaseCtrl';
import { wizardParentState } from '../RouteConfig';

var fn = function fn($scope, $state) {
    $scope.flowModel = $state.get(wizardParentState).data.flow;

    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {};

    ctrl.create($scope);

    $scope.$watch('flowModel.currentStep', function () {
        $scope.isConfirmationStep = $scope.flowModel.currentStep.name === 'Confirmation';
    });
};
fn.$inject = ['$scope', '$state'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/AddBuildingWizard/wrapper/WrapperCtrl.js
// module id = 985
// module chunks = 0